module.exports = __webpack_public_path__ + "img/home.9ce7bf33.png";